'use client';

import dynamic from 'next/dynamic';
import React from 'react';

// Lazy load the Shadow DOM component with intersection observer
const LazyProductArchitectureV2Shadow = dynamic(
  () => import('./ProductArchitectureV2Shadow'),
  {
    ssr: false, // Shadow DOM must be client-side only
    loading: () => (
      <div className="flex items-center justify-center h-[600px] my-8">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4" />
          <p className="text-gray-600">Loading architecture builder...</p>
        </div>
      </div>
    )
  }
);

// Wrapper with intersection observer for true lazy loading
export default function LazyProductArchitectureV2ShadowWrapper(props: any) {
  const [shouldLoad, setShouldLoad] = React.useState(false);
  const containerRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setShouldLoad(true);
          observer.disconnect();
        }
      },
      {
        // Load when component is 200px away from viewport
        rootMargin: '200px',
        threshold: 0
      }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div ref={containerRef}>
      {shouldLoad ? (
        <LazyProductArchitectureV2Shadow {...props} />
      ) : (
        <div className="flex items-center justify-center h-[600px] my-8">
          <div className="text-center text-gray-400">
            <p className="text-sm">Architecture builder will load when visible</p>
          </div>
        </div>
      )}
    </div>
  );
}